import flexibility from 'flexibility';
import * as React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {Subject} from 'rxjs';
import {ApplicationsComponent} from './components/applications/applications.component';
import {ContactComponent} from './components/contact/contact.component';
import {DesignComponent} from './components/design/design.component';
import {FoundersComponent} from './components/founders/founders.component';
import {HomeComponent} from './components/home/home.component';
import {IntroductionComponent} from './components/introduction/introduction.component';
import {MainLayoutRoute} from './components/layouts/main.layout';
import {MarketingComponent} from './components/marketing/marketing.component';
import {OutsourcingComponent} from './components/outsourcing/outsourcing.component';
import {TeamComponent} from './components/team/team.component';
import './scss/index.scss';

(window as any).siteEventSubscribers = {
    navigation: {
        status: new Subject()
    },
    window: {
        resize: new Subject()
    },
    contentScroll: new Subject()
};

(window as any).preventHammerSwipe = false;

window.addEventListener('resize', () => (window as any)
    .siteEventSubscribers.window.resize.next());

const root = createRoot(document.getElementById('appRoot') as HTMLElement);

root.render(<BrowserRouter>
    <Routes>
        <Route element={<MainLayoutRoute/>}>
            <Route path={'/'} element={<HomeComponent/>}/>
            <Route path={'/ceo'} element={<IntroductionComponent/>}/>
            <Route path={'/cto'} element={<ApplicationsComponent/>}/>
            <Route path={'/marketing'} element={<MarketingComponent/>}/>
            <Route path={'/references'} element={<DesignComponent/>}/>
            <Route path={'/outsourcing'} element={<OutsourcingComponent/>}/>
            <Route path={'/founders'} element={<FoundersComponent/>}/>
            <Route path={'/team'} element={<TeamComponent/>}/>
            <Route path={'/contact'} element={<ContactComponent/>}/>
        </Route>
    </Routes>
</BrowserRouter>);

setTimeout(() => {
    flexibility(document.documentElement);
}, 5000);
